import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AicraftFavorite } from 'src/app/core/favorites/favoriteAircraft.service';
import { CompanyFavorite } from 'src/app/core/favorites/favoriteCompany.service';
export enum CallbackComponent {
    aircraft,
    Company,
    customCallback
}
@Component({
  selector: 'app-favorite-icon',
  templateUrl: './favorite-icon.component.html',
  styleUrls: ['./favorite-icon.component.scss']
})
export class FavoriteIconComponent implements OnInit {
    @Input() favoriteData: any;
    @Input() callbackComponent: CallbackComponent = CallbackComponent.aircraft;
    @Input() isSaving: boolean = false;
    @Input() hasPadding: boolean = true;
    @Input() customers: [] = [];
    @Output() favoriteClick: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private aicraftFavorite: AicraftFavorite,
        private companyFavorite: CompanyFavorite    
        ) { }

    ngOnInit() {
        this.isFavorite = this.getIsFavoriteDefaultValue;
    }

    ngOnChanges(changes: SimpleChanges){ 
        if(changes.favoriteData){
            this.isFavorite = this.getIsFavoriteDefaultValue;
        }    
    }
    private _isFavorite: boolean = false;
    get isFavorite(): boolean {
        return this._isFavorite;
    }
    set isFavorite(value: boolean) {
        this._isFavorite = value;
    }
    
    get getIsFavoriteDefaultValue(): boolean{
        switch(this.callbackComponent) {
            case CallbackComponent.aircraft: {
               return this.aicraftFavorite.getIsFavoriteDefaultValue(this.favoriteData);
            }
            case CallbackComponent.Company: {
                return this.companyFavorite.getIsFavoriteDefaultValue(this.favoriteData);
            }
            default: {
                return false;
            }
        }    
    }
    async toogleFavorite(): Promise<AicraftFavorite>{
        if(this.isSaving) return;

        this.isFavorite = !this.isFavorite;
        this.favoriteData.isFavorite = this.isFavorite;
        switch(this.callbackComponent) {
            case CallbackComponent.aircraft: {
               this.aicraftFavorite.customers = this.customers;
               this.favoriteData = await this.aicraftFavorite.toogleFavorite(this.favoriteData);
               this.isFavorite = this.favoriteData.isFavorite;
               break;
            }
            case CallbackComponent.Company: {
                this.favoriteData = await this.companyFavorite.toogleFavorite(this.favoriteData);  
                this.isFavorite = this.favoriteData.isFavorite;
               break;
            }
            default: {
                this.favoriteClick.emit(this.favoriteData);
                break;
            }
         }
         this.favoriteClick.emit(this.favoriteData);
         return this.favoriteData;

    }
}
